<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Target - {{ data.salesTeam.name }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <div>
      <div class="mat-table-wrapper" style="max-height: calc(100% - 130px)">
        <mat-table class="lmat-elevation-z8" [dataSource]="entities" style="min-width: 100%">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>Entity Name </mat-header-cell>
            <mat-cell *matCellDef="let entity">{{ entity | getEntityName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef>Type </mat-header-cell>
            <mat-cell *matCellDef="let entity">{{ entity.entity_type }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <div class="mat-table__message" *ngIf="entities.length === 0">
          {{ 'TABLE.NO_RECORDS' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>{{ 'TABLE.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
